export const platforms = [
    {label:'AWS' , value: 'aws'},
    {label:'Azure' , value: 'azure'},
    {label:'Teradata Cloud' , value: 'tmc'}
]